<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-sm-10 col-md-6 col-lg-4 g-0">
      <app-title title="pool organiseren"></app-title>

      @if(alert){
        <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
      }

      @if(processing()){
        <h2 class="text-center">
          <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
        </h2>
      }

      @if(!processing() && competitionConfig){
      <form name="form" class="max-form-width" (ngSubmit)="create(competitionConfig)" [formGroup]="form" novalidate>
        <div class="row g-3">
          <label for="name" class="col-4 col-form-label">naam</label>
          <div class="col-8">
            <input class="form-control"
              ngClass="{ 'is-invalid': form.controls.name.invalid, 'is-valid': form.controls.name.valid }" type="text"
              formControlName="name" placeholder="max. {{validations.maxlengthname}} karakters">
          </div>
        </div>
        <div class="row mt-3 justify-content-end">
          <div class="col-8">
            <button [disabled]="form.invalid" type="submit" class="btn btn-primary">
              pool maken
            </button>
          </div>
        </div>
      </form>
      }
    </div>
  </div>
</div>